import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export function useCheckNationalTest() {
  return useMutation({
    mutationFn: async ({
      testId,
      optionId,
      answer
    }: {
      testId?: number;
      optionId?: number | null;
      answer?: string;
    }) => {
      const { data } = await $apiV2.post(`/nat-certificate/check`, { id: testId, option_id: optionId, answer });

      return data;
    },
    onError: errorHandler()
  });
}
